import React from 'react';

export const checkoutArchiveColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'نام کافه',
    dataIndex: 'cafeName',
    name: 'cafeName',
    isSortable: true,
  },
  {
    title: 'مجموع پیش پرداخت',
    dataIndex: 'sumCafeBasePrice',
    name: 'sumCafeBasePrice',
    isSortable: true,
    render: (sumCafeBasePrice) => <div>{Number(sumCafeBasePrice).toLocaleString()}</div>,
  },
  {
    title: 'مجموع ورودی ',
    dataIndex: 'sumTotalEntranceAmount',
    name: 'sumTotalEntranceAmount',
    isSortable: true,
    render: (sumTotalEntranceAmount) => <div>{Number(sumTotalEntranceAmount).toLocaleString()}</div>,
  },
  {
    title: 'مجموع پیش پرداخت + ورودی ',
    dataIndex: 'sumCafePrices',
    name: 'sumCafePrices',
    isSortable: true,
    render: (sumCafePrices) => <div>{Number(sumCafePrices).toLocaleString()}</div>,
  },
  {
    title: 'جمع سهم کافه',
    dataIndex: 'sumToBePaidToCafePrice',
    name: 'sumToBePaidToCafePrice',
    isSortable: true,
    className:'direction-ltr',
    render: (sumToBePaidToCafePrice) => <div>{Number(sumToBePaidToCafePrice).toLocaleString()}</div>,
  },
  {
    title: 'جمع سهم آرسی',
    dataIndex: 'sumRseeStockAmount',
    name: 'sumRseeStockAmount',
    isSortable: true,
    render: (minCheckout) => <div>{Number(minCheckout).toLocaleString()}</div>,
  },
  {
    title: 'حد تسویه',
    dataIndex: 'minCheckout',
    name: 'minCheckout',
    isSortable: true,
    render: (minCheckout) => <div>{Number(minCheckout).toLocaleString()}</div>,
    // render: (balance) => (
    //   <div className={`direction-ltr ${balance < 0 && 'red-color'}`}>{Number(balance).toLocaleString()}</div>),
  },
  {
    title: 'مبلغ تسویه',
    dataIndex: 'sumToBePaidToCafePrice',
    name: 'sumToBePaidToCafePrice',
    isSortable: true,
    render: (sumToBePaidToCafePrice) => <div>{Number(sumToBePaidToCafePrice).toLocaleString()}</div>,
  },
  {
    title: 'تعداد رزروها',
    dataIndex: 'reservesCount',
    name: 'reservesCount',
    isSortable: true,
  },
  {
    title: 'تاریخ تسویه حساب',
    dataIndex: 'checkoutAt',
    name: 'checkoutAt',
    isSortable: true,
  },
  {
    title: 'عملیات',
    action: (item, action) => (
      <>
        <a
          onClick={e => {
            e.preventDefault();
            action.checkoutReserves(item);
          }}
          href="#"
          className="text-success"
        >
          {locales('labels.relatedReservation')}
        </a>
        <span style={{
          borderLeft: '2px solid green',
          padding: '2px',
          marginLeft: '3px',
        }}/>
        <a
          onClick={e => {
            e.preventDefault();
            action.showDetails(item);
          }}
          href="#"
          className="text-success"
        >
          {locales('titles.details')}
        </a>
      </>
    ),
  },
];
